import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, model, ViewEncapsulation } from '@angular/core';
import { DocumentLineItemDisplayClass } from '../widget-add-edit-document-line-item/types-interfaces';

@Component({
  selector: 'app-document-line-item-position-text',
  templateUrl: './document-line-item-position-text.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgClass,
  ]
})
export class DocumentLineItemPositionTextComponent {

  modelSig = model<DocumentLineItemDisplayClass>({} as DocumentLineItemDisplayClass);

  toggleChildren() {
    let newVal = !this.modelSig().childrenHidden();
    this.modelSig().childrenHidden.set(newVal);
    this.modelSig().childrenHiddenChanged.next(newVal);
  }

}
